import { render } from "./TabsTitle.vue?vue&type=template&id=5da6dd80&scoped=true&ts=true"
import script from "./TabsTitle.vue?vue&type=script&lang=ts"
export * from "./TabsTitle.vue?vue&type=script&lang=ts"

import "./TabsTitle.vue?vue&type=style&index=0&id=5da6dd80&lang=less&scoped=true"

import exportComponent from "/Users/jiangshanwen/workspace/website-3.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5da6dd80"]])

export default __exports__